import parsePhoneNumber from "libphonenumber-js";
import "./PhoneInput.scss";
// This is fix for Vite build. See: https://github.com/vitejs/vite/issues/2139#issuecomment-1165016994
import RPI from "react-phone-input-2";
import { forwardRef, Ref, useImperativeHandle, useRef } from "react";
// @ts-ignore
const PhoneInput2 = RPI.default ? RPI.default : RPI;

interface PhoneData {
  countryCallCode: string;
  nationalNumber: string;
}

type _SupportedRef = { focus: () => void };

interface Props {
  value: PhoneData;
  onChange: (value: PhoneData) => void;
  isValid: boolean;
  onBlur?: () => void;
  ref?: Ref<_SupportedRef>;
  id?: string;
  disabled?: boolean;
}

export const PhoneInput = forwardRef<_SupportedRef, Props>(
  ({ value, onChange, isValid, onBlur, id, disabled }, ref) => {
    const inputRef = useRef<HTMLInputElement>();

    // Hacky solution taken from here: https://github.com/bl00mber/react-phone-input-2/issues/187#issuecomment-868700779
    useImperativeHandle(ref, () => ({
      focus: () => {
        if (!inputRef.current) {
          return;
        }

        const current = inputRef.current as unknown as { numberInputRef: Pick<HTMLInputElement, "focus"> };
        current.numberInputRef?.focus();
      },
    }));

    return (
      <PhoneInput2
        country="US"
        placeholder="Enter phone number"
        value={value.countryCallCode + value.nationalNumber}
        onChange={(value: string) => {
          // + must be added, is is not working correctly if its missing
          const parsed = parsePhoneNumber(`+${value}`);

          if (parsed?.countryCallingCode !== undefined) {
            onChange({ countryCallCode: parsed.countryCallingCode, nationalNumber: parsed.nationalNumber });
          } else {
            onChange({ countryCallCode: "", nationalNumber: "" });
          }
        }}
        isValid={isValid}
        onBlur={onBlur}
        ref={inputRef}
        inputProps={{ id: id }}
        disabled={disabled}
      />
    );
  },
);
